( function (){
    window.publishEvent && window.publishEvent('critial-js-complete');
})();


// WEBPACK FOOTER //
// ./shared_critical/post_critical_js_load.js